import React, { useEffect, useState } from "react"
import { Controller } from "react-hook-form"

import { AdminRegion, Country } from "../../generated/api"
import { utilitiesApi } from "../../services/api"

import CountrySelector from "./CountrySelector"
import RegionSelector from "./RegionSelector"
import SearchableCountryRegionSelector from "./SearchableCountryRegionSelector"

interface CountryRegionProps {
  control: any
  setValue: any
  clearErrors: any
  isOptional ?: boolean
}

const CountryRegionSelector = ({ control, setValue, clearErrors, isOptional = false }: CountryRegionProps) => {
  const [selectedCountry, setSelectedCountry] = useState<Country | null>(null)
  const [selectedRegion, setSelectedRegion] = useState<AdminRegion | null>(null)

  return (
    <div className="country-region__container">
      <SearchableCountryRegionSelector
        selectedCountry={selectedCountry}
        setSelectedCountry={setSelectedCountry}
        selectedRegion={selectedRegion}
        setSelectedRegion={setSelectedRegion}
        isCountryOptional = {isOptional}
        isRegionOptional = {isOptional}
        isCurrencyOptional = {isOptional}
        control={control}
        supportHookForm={true} // prop to support hook form //(optional)false by default
      />
    </div>
  )
}

export default CountryRegionSelector
